import {
  ApolloClient,
  InMemoryCache,
  HttpLink,
  from,
} from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import refreshLink from '@/modules/myStageGraphQL/RefreshLink';
import { 
    myStageGraphQlEndpoint, 
    mystageServiceIdHeaderName, 
} from '@/utils/constants';
import { 
  getMyStageToken,
  getMyStageRefreshToken,
  getServiceId 
} from '@/modules/myStageGraphQL/AuthCookieManager';
import VueApollo from 'vue-apollo';
import logger from '@/modules/Logger';

const authLink = setContext((_, { headers, authRequired }) => {
  if (authRequired === false) {
    return { headers };
  }
  
  const token = getMyStageToken();
  const refreshToken = getMyStageRefreshToken();
  const serviceId = getServiceId();

  if ((!token && !refreshToken) || !serviceId) {
    logger.error(`[MYSTAGE][AUTH] MyStage token or service id is missing`, {
      operation: "mystage_graphql_request"
    })
    throw new Error('MyStage token or service id is missing');
  }

  return {
    headers: {
      ...headers,
      Authorization: token ? `Bearer ${token}` : '',
      [mystageServiceIdHeaderName]: serviceId ? serviceId : ''
    },
  };
});

const httpLink = new HttpLink({
  uri: myStageGraphQlEndpoint,
  credentials: 'omit',
});

const apolloClient = new ApolloClient({
  link: from([refreshLink, authLink, httpLink]),
  cache: new InMemoryCache(),
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

export { apolloProvider, apolloClient };
